// extracted by mini-css-extract-plugin
export var searchHeader = "_ad-0";
export var searchHeaderDark = "_ad-1";